import { PAYER_EIN_TOOLTIP, PAYER_SSN_TOOLTIP } from "../../web/businesslogic/components/addpayernew/constant";
import { PAYER_TYPE_1042_S, PAYER_TYPE_1042_S_TITLES, PAYER_TYPE_TITLE } from "../../web/businesslogic/components/addpayernew/createone/getpayertype/constants";
import General from "./General";

export default class Payer {
    static handleSelectOptionClick(idx, setSelectedOption) {
        setSelectedOption(idx);
    }

    static convertToSSN(input) {
        const digits = input.replace(/\D/g, '');
        const part1 = digits.slice(0, 3);
        const part2 = digits.slice(3, 5);
        const part3 = digits.slice(5, 9);
        const formatted = [part1, part2, part3].filter(Boolean).join('-');

        return formatted;
    }

    static convertToEIN(input) {
        const digits = input.replace(/\D/g, '');
        const part1 = digits.slice(0, 2);
        const part2 = digits.slice(2, 9);
        const formatted = [part1, part2].filter(Boolean).join('-');

        return formatted;
    }

    static removeHyphens(input) {
        return `${input}`.replace(/-/g, "");
    }

    static getPayerTINByIdType(idType, idNumber = "", hideTIN = false) {

        if ((idType === "SSN" || idType === "Individual") && hideTIN) {
            return `XX-XXX-${idNumber.slice(-4)}`;
        }

        if ((idType === "EIN" || idType === "Business") && hideTIN) {
            return `XX-XXX${idNumber.slice(-4)}`;
        }

        switch (idType) {
            case "SSN":
                return Payer.convertToSSN(idNumber);
            case "EIN":
                return Payer.convertToEIN(idNumber);
            case "Business":
                return Payer.convertToEIN(idNumber);
            case "Individual":
                return Payer.convertToSSN(idNumber);
            default:
                return "N/A"
        }
    }

    static extractNumberFromW8W9Message(str) {
        const pattern = /Count is (\d+)/;

        const matches = str.match(pattern);

        if (matches && matches.length) {
            return General.extractIntegerFromString(matches[0])
        } else {
            return 0;
        }
    }

    static formatExpiryDate(date) {
        const regex = /^(\d{2})(\d{2})$/;
        const matches = regex.exec(date);

        if (matches && matches.length === 3) {
            const month = matches[1];
            const year = matches[2];
            return { value: `${month}/${year}` };
        }

        return { value: date };
    }

    static getPayerFederalIdType(payerType, is1042SForm = false) {
        if (is1042SForm) {
            return PAYER_TYPE_1042_S.find(r => r.title === payerType)?.value;
        } else {
            return payerType === PAYER_TYPE_TITLE.INDIVIDUAL ? "SSN" : "EIN";
        }
    }

    static getTINProps(payerType, tinValue) {
        switch (payerType) {
            case PAYER_TYPE_TITLE.BUSINESS:
            case PAYER_TYPE_1042_S_TITLES.NQI_EIN:
            case PAYER_TYPE_1042_S_TITLES.QI_WP_WT_EIN:
                return {
                    tinTooltip: PAYER_EIN_TOOLTIP,
                    tinPlaceholder: "XX - XXXXXXX",
                    tinValue: Payer.convertToEIN(tinValue),
                    tinRules: { regex: { pattern: /^\d{2}-\d{7}$/, message: "Please enter a valid EIN" }, required: true },
                    showNames: false,
                    tinDisabled: false,
                }

            default:
                return {
                    tinTooltip: PAYER_SSN_TOOLTIP,
                    tinPlaceholder: 'XXX - XX - XXXX',
                    tinValue: Payer.convertToSSN(tinValue),
                    tinRules: { regex: { pattern: /^\d{3}-\d{2}-\d{4}$/, message: "Please enter a valid SSN" }, required: true },
                    showNames: true,
                    tinDisabled: false,
                }
        }
    }

    static getPayerTypeFromId(idType) {
        switch (idType) {
            case PAYER_TYPE_1042_S_TITLES.EIN:
            case PAYER_TYPE_1042_S_TITLES.NQI_EIN:
            case PAYER_TYPE_1042_S_TITLES.QI_WP_WT_EIN:
                return PAYER_TYPE_TITLE.BUSINESS;

            default:
                return PAYER_TYPE_TITLE.BUSINESS;
        }
    }

    static getPayerType(PayerType) {
        if (PayerType === PAYER_TYPE_TITLE.INDIVIDUAL || PayerType === PAYER_TYPE_TITLE.BUSINESS) {
            return PayerType;
        } else {
            return "";
        }
    }
}